import { Content } from './Content/Content'
import { Loader } from './Components/Loader/Loader'
import {
  TranslationsContextProvider,
  useTranslationsContext
} from './TranslationsContext'
import { MetaTags } from './Content/MetaTags'

export function App() {
  return (
    <TranslationsContextProvider>
      <TranslationsLoader>
        <Content />
      </TranslationsLoader>
    </TranslationsContextProvider>
  )
}

interface Props {
  children: JSX.Element
}

function TranslationsLoader(props: Props) {
  const translations = useTranslationsContext()

  return (
    <>
      <Loader areTranslationsLoading={translations.isLoading} />
      {translations.isLoading ? null : <MetaTags />}
      {!translations.isLoading && props.children}
    </>
  )
}
